// KPI listeleri kategori ağacı (Özet, Disclosure, Hedefler, portal Özet) — tek kopya kaynağı.
// Müşteri yüzeyinde de kullanılır: "AI"/"üretim"/"danışman notu" ifadesi YOK.
export const KPI_TREE_COPY = {
  collapseAll: "Tümünü daralt",
  expandAll: "Tümünü genişlet",
  toolbarLabel: "Kategori ağacı",
  /** bant sayacı — süzgeç açıkken "3 / 7" (uyan / toplam), kapalıyken yalnız toplam */
  counter: (matching: number, total: number, filtered: boolean): string =>
    filtered ? `${matching} / ${total}` : `${total}`,
  toggle: (label: string, collapsed: boolean): string =>
    `${label} — ${collapsed ? "aç" : "daralt"}`,
} as const;
